import SimpleCrypto from "simple-crypto-js";


class Auth {
    constructor() {
        this.authenticated = false;
        this.idLogin = "";
        this.idEmpresa = "";
        this.tipoUsuario = "";
        this.nombre = "";
        this.nombreUsuario = "";
        this.idCliente = "";
        this.secretKey = "gtic.1234";
        this.simpleCrypto = new SimpleCrypto(this.secretKey);
    }
    setIdLogin(user, company, type, name, seller, userName,idclient){
        this.idLogin = user;
        this.idEmpresa = company;
        this.tipoUsuario= type;
        this.nombre=name;
        this.vendedor=seller;
        this.nombreUsuario=userName;
        this.idCliente=idclient;
    }

    login(cb) {
        ////console.log(this.idLogin+this.idEmpresa+this.tipoUsuario)
        this.authenticated = true;
        const encLogin = this.simpleCrypto.encrypt(this.idLogin);
        const encCompany = this.simpleCrypto.encrypt(this.idEmpresa);
        const encTipo = this.simpleCrypto.encrypt(this.tipoUsuario);
        ////console.log("--->"+encLogin+encCompany+encTipo)
        sessionStorage.setItem('_id', this.idLogin);
        sessionStorage.setItem('company', this.idEmpresa);
        sessionStorage.setItem('tipo', this.tipoUsuario);
        sessionStorage.setItem('nombre', this.nombre);
        sessionStorage.setItem('vendedor', this.vendedor);
        sessionStorage.setItem('usuario', this.nombreUsuario);
        sessionStorage.setItem('id_cliente', this.idCliente);
        sessionStorage.setItem('ctrlEmp', encCompany);
        sessionStorage.setItem('ctrluser', encLogin);
        sessionStorage.setItem('ctrltipo', encTipo);
        if(this.tipoUsuario==="4" || this.tipoUsuario==="1"  ) sessionStorage.setItem('aprobacion', 1);
        cb();
    }

    logout(){
        this.authenticated = false;
        sessionStorage.removeItem('_id');
        sessionStorage.removeItem('company');
        sessionStorage.removeItem('vendedor');
        sessionStorage.removeItem('usuario');
        sessionStorage.removeItem('tipo');
        sessionStorage.removeItem('ctrlEmp');
        sessionStorage.removeItem('ctrluser');
        sessionStorage.removeItem('ctrltipo');
        sessionStorage.removeItem('nombre');
        sessionStorage.removeItem('fact');
        sessionStorage.removeItem('cat');
        sessionStorage.removeItem('est');
        sessionStorage.removeItem('ven');
        sessionStorage.removeItem('ped');
        sessionStorage.removeItem('inv');
        sessionStorage.removeItem('menu');
        sessionStorage.removeItem('arc');
        sessionStorage.removeItem('menu');
        sessionStorage.removeItem('id_cliente');
        sessionStorage.removeItem('pos');
        sessionStorage.removeItem('nom');
        sessionStorage.removeItem('aped');
        sessionStorage.removeItem('aprobacion');
    }
    
    isAuthenticated(){
        const user = ( sessionStorage.getItem('_id') || "");
        const ctrlUser =  sessionStorage.getItem('ctrluser');

        const company =  (sessionStorage.getItem('company') || "");
        const ctrlCompany =  sessionStorage.getItem('ctrlEmp');


        const tipo =  (sessionStorage.getItem('tipo') || "" );
        const ctrlTipo =  sessionStorage.getItem('ctrltipo');

        const dencUser = (ctrlUser) ? this.simpleCrypto.decrypt(ctrlUser): '--';
        const dencCompany = (ctrlCompany) ? this.simpleCrypto.decrypt(ctrlCompany): '--';
        const dencType = (ctrlTipo) ? this.simpleCrypto.decrypt(ctrlTipo): '--';

        this.authenticated = ( user.toString() === dencUser.toString() && company.toString() === dencCompany.toString() && tipo.toString() === dencType.toString() ) ? true : false;

        return this.authenticated;
    }

    setPermisos(current){
        const fact = current.FACTURACION_ELECTRONICA;
        const cat = current.CATALOGO;
        const est = current.ESTRUCTURACION;
        const ven = current.VENTAS;
        const ped = current.PEDIDOS;
        const inv = current.INVENTARIO;
        const arc = current.ARCHIVOS;
        const pos = current.POS;
        const nom = current.NOMINA;
        const aped = current.ADMIN_PEDIDOS;
        if(fact){
            sessionStorage.setItem('fact', fact);
        }
        if(cat){
            sessionStorage.setItem('cat', cat);
        }
        if(est){
            sessionStorage.setItem('est', est);
        }
        if(ven){
            sessionStorage.setItem('ven', ven);
        }
        if(ped){
            sessionStorage.setItem('ped', ped);
        }
        if(inv){
            sessionStorage.setItem('inv', inv);
        }
        if(arc){
            sessionStorage.setItem('arc', arc);
        }
        if(pos){
            sessionStorage.setItem('pos', pos);
        }
        if(nom){
            sessionStorage.setItem('nom', nom);
        }
        if(aped){
            sessionStorage.setItem('aped', aped);
        }
    }
}


export default new Auth();